import React, {useCallback} from 'react';

import {useLanguage} from 'context/language-context';
import {getPrivacyPolicy, getTermsAndConditions} from 'helpers/termsAndPrivacy';
import styles from './PublicPageFooter.module.scss';

const PublicPageFooter = () => {
    const {selectedLanguage} = useLanguage();

    const getTermsAndConditionsUrl = useCallback(
        () => getTermsAndConditions(selectedLanguage),
        [selectedLanguage],
    );

    const getPrivacyPoliciyUrl = useCallback(
        () => getPrivacyPolicy(selectedLanguage),
        [selectedLanguage],
    );

    return (
        <div className={styles.container}>
            <p>
                <var data-var="year">© {new Date().getFullYear()} amnis. </var>
                All rights reserved.
            </p>
            <a
                href={getTermsAndConditionsUrl()}
                target="_blank"
                rel="noopener noreferrer"
            >
                Terms and conditions
            </a>
            <a
                href={getPrivacyPoliciyUrl()}
                target="_blank"
                rel="noopener noreferrer"
            >
                Privacy policies
            </a>
        </div>
    );
};

export default PublicPageFooter;
